import React from 'react';
// MUI Skeleton replaced with a styled <div> that does the same shimmer.
// AssessmentShell is eagerly imported by src/routes/index.jsx, so any
// @mui/material dependency here would land in the home-route entry chunk.
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import Logo from 'assets/images/profitroll-logo-colored.svg?react';

const skeletonPulse = keyframes`
  0%   { opacity: 1; }
  50%  { opacity: 0.4; }
  100% { opacity: 1; }
`;

// Mirrors MUI v9 Skeleton variant="text"/"rectangular":
//   - text: ~0.83 line-height block with 4 px radius
//   - rectangular: caller-controlled rounding via `rounded`
const SkeletonBox = styled('span')(({ width, height, rounded }) => ({
  display: 'block',
  width: typeof width === 'number' ? `${width}px` : width || '100%',
  height: typeof height === 'number' ? `${height}px` : height || 16,
  backgroundColor: 'rgba(0, 0, 0, 0.11)',
  borderRadius: rounded || 4,
  animation: `${skeletonPulse} 1.5s ease-in-out 0.5s infinite`
}));

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: 20,
  backgroundColor: '#f5f5f5',
});

const Card = styled('div')({
  backgroundColor: '#fff',
  borderRadius: 24,
  padding: 32,
  maxWidth: 600,
  width: '100%',
});

const LogoWrap = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 24,
});

const LogoImg = styled(Logo)({
  height: 36,
});

const Row = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12,
  marginBottom: 24,
});

const ButtonStack = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  marginTop: 8,
});

export default function AssessmentShell() {
  return (
    <Container>
      <Card>
        <LogoWrap><LogoImg /></LogoWrap>

        <Row>
          <SkeletonBox width="70%" height={36} />
          <SkeletonBox width="92%" height={20} />
          <SkeletonBox width="88%" height={20} />
          <SkeletonBox width="80%" height={20} />
        </Row>

        <Row>
          <SkeletonBox width="100%" height={64} rounded={8} style={{ marginBottom: 8 }} />
          <SkeletonBox width="100%" height={64} rounded={8} style={{ marginBottom: 8 }} />
          <SkeletonBox width="100%" height={64} rounded={8} />
        </Row>

        <ButtonStack>
          <SkeletonBox width="100%" height={48} rounded={25} />
          <SkeletonBox width="100%" height={48} rounded={25} />
        </ButtonStack>
      </Card>
    </Container>
  );
}
